module.exports = __webpack_public_path__ + "assets/images/imc_r.d789881a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/imc_r.png
// module id = 747
// module chunks = 1